<template>
  <div class="node-list">
    <NodeListTile v-for="node in nodes" :node="node"/>
    <div class="list-tile" v-if="parent === 0" :class="{active:mapStore.state.defGuide}"
         @click="_ => mapStore.goToDefGuide()">
      <p class="title">
        Definitions and Guidelines
      </p>
    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent, inject, onMounted, PropType} from "vue";
import NodeListTile from "@/components/NodeListTile.vue";
import {useMapStore} from "@/mixins/mapStore";

export default defineComponent({
  name: "NodeList",
  components: {NodeListTile},
  props: {
    parent: {
      type: Number
    }
  },
  setup(props) {
    const mapStore = useMapStore()
    const nodes = mapStore.getNodesByParent(props.parent);
    if (nodes.length == 1) {
      mapStore.addToNodePath(nodes[0]);
    }
    return {
      nodes,
      mapStore
    }
  }
})

</script>
<style lang="scss">
@import "src/assets/styles/vars";

.node-list {
  height: 100%;
  width: 100%;
}
</style>t